<template>
    <div class="new-header">
        <div class="main" flex="cross:center">
            <div class="logo" @click="$router.push({
                name: 'Index'
            })">
                <img src="@/assets/image2/logo.png" />
            </div>
            <div class="nav" flex="cross:center">
                <div class="item" :class="{active: active == 1}" @click="$router.push({
                    name: 'Index'
                })">{{$lang.get().home}}</div>
                <div class="item" :class="{active: active == 2}" @click="$router.push({
                    name: 'Books'
                })">{{$lang.get().books}}</div>
                <div class="item" :class="{active: active == 3}" @click="$router.push({
                    name: 'Video'
                })">{{$lang.get().video}}</div>
                <div class="item" :class="{active: active == 4}" @click="$router.push({
                    name: 'Article'
                })">{{$lang.get().exhibition}}</div>
                <div class="item" :class="{active: active == 5}" @click="$router.push({
                    name: 'Contact'
                })">{{$lang.get().contactUs}}</div>
            </div>
            <div class="flex-1"></div>
            <div class="mobile">
                {{$lang.get().mobile}}
                <div class="mobile-box">
                    <img v-if="$lang.getLang() == 'cn'" :src="$util.img(pcConfig.mobile_cn)" />
                    <img v-else  :src="$util.img(pcConfig.mobile_en)" />
                </div>
            </div>
            <div class="login" v-if="!$parent.$parent.user" flex="cross:center main:center" @click="$router.push({
                    name: 'Login'
                })">{{$lang.get().logRegister}}</div>
            <div v-else class="user-head" flex="cross:center">
                <img :src="$util.img($parent.$parent.user.avatar)" @click="$router.push({
                    name: 'Collect'
                })" />
                <div class="logout" @click="toLogout">{{$lang.getLang() == 'cn' ? '退出登录' : 'Logout'}}</div>
            </div>
            <!-- <div class="login" v-else flex="cross:center main:center" @click="$router.push({
                    name: 'Collect'
                })">{{$lang.get().userCenter}}</div> -->
            <div class="lang" :class="{'lang-none': $lang.getLang() == 'cn'}" @click="changeLang('cn')">中文</div>
            <div class="lang" :class="{'lang-none': $lang.getLang() == 'en'}" @click="changeLang('en')">English</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: {
            type: Number,
            default: 1
        }
    },
    data(){
        return {
            pcConfig: {}
        }
    },
    mounted(){
        this.getPcConfig()
    },
    methods: {
        changeLang(lang) {
            this.$lang.set(lang)
            window.location.href = ''
        },
        async getPcConfig(){
            let res = await this.$api.rApi('config/pc/info')
            if(res.status == 1){
                let pcConfig = {}
                res.data.forEach(item => {
                    if(item.name == 'cn_index_swiper' || item.name == 'en_index_swiper'){
                        item.value = item.value ? JSON.parse(item.value) : []
                    }
                    pcConfig[item.name] = item.value
                })
                this.pcConfig = pcConfig
            }
        },
        toLogout(){
            this.$util.cacheSet('AuthToken', '')
            this.$parent.$parent.user = null
            this.$forceUpdate()
            this.$router.push({
                name: 'Login'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .new-header{
        height: 50px;
        background: #006346;
        .main{
            height: 50px;
        }
        .logo{
            font-size: 0;
            img{
                width: 108.96px;
                height: 25.82px;
                cursor: pointer;
            }
        }
        .nav{
            margin-left: 76px;
            .item{
                height: 50px;
                line-height: 50px;
                margin-left: 86px;
                font-family: Arial, Arial;
                font-weight: 400;
                font-size: 13px;
                color: #FFFFFF;
                cursor: pointer;
                &.active{
                    color: #FFD900;
                }
            }
        }
        .mobile{
            font-family: Arial, Arial;
            font-weight: bold;
            font-size: 13px;
            color: #FFD900;
            text-decoration: underline;
            margin-right: 27px;
            cursor: pointer;
            position: relative;
            z-index: 9;
            .mobile-box{
                display: none;
                position: absolute;
                left: 0;
                top: 30px;
                background: #fff;
                z-index: 99;
                padding: 10px;
                border-radius: 5px;
                img{
                    width: 200px;
                    height: 200px;
                }
            }
            &:hover{
                .mobile-box{
                    display: block;
                }
            }
        }
        .login{
            width: 92px;
            height: 29px;
            border-radius: 15px 15px 15px 15px;
            border: 1px solid #FFFFFF;
            font-weight: 400;
            font-size: 12px;
            color: #FFFFFF;
            cursor: pointer;
        }
        .logout{
            font-size: 12px;
            margin-left: 15px;
            color: #FFFFFF;
            cursor: pointer;
        }
        .user-head{
            img{
                cursor: pointer;
                width: 30px;
                height: 30px;
                border-radius: 15px;
            }
        }
        .lang{
            font-family: Arial, Arial;
            font-weight: 400;
            font-size: 12px;
            margin-left: 16px;
            color: rgba(#fff, 0.6);
            cursor: pointer;
        }
        .lang-none{
            font-family: Arial, Arial;
            font-weight: 400;
            font-size: 12px;
            color: rgba(#fff, 1);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/NewHeader.vue